import React from "react";
import CommsTopBanner from "./TopBanner";
import UiMainWrapper from "../../components/common/UiMainWrapper";
import TopHeader from "../../components/header/TopHeader";
import {
    UiCol,
    UiRowContainer,
    UiSingleRow,
} from "../../components/grid-container/GridContainer";
import {
    UiContentWr,
    UiContentCol,
    UiTabContentWr,
} from "../../components/common/UiPageElements";
import nyImage2 from "../../../../styles/img/ttny-2.jpg";
import nyImage3 from "../../../../styles/img/ttny-3.jpg";
import nyImage4 from "../../../../styles/img/ttny-4.jpg";
import Footer from "../../components/footer/Footer";
import { UiSlider } from "../../components/common/UiSlider";
import {
    UiNextArrow,
    UiPrevArrow,
} from "../../components/common/UiSliderArrows.jsx";
import { UiButtonPrimary } from "../../../_uiComponents/form/UiButton";

export default function CommsPage(props) {
    
    return (
        <>
            {/* <UiMainWrapper>
                <TopHeader /> */}
            <CommsTopBanner />
            <UiContentWr>
                <UiSingleRow>
                    <UiCol lg="7" className="pb-3 pb-md-0">
                        <div className="mb-4">
                            <UiButtonPrimary btnName="Start" />
                        </div>
                        <UiSingleRow>
                            <UiCol
                                lg="7"
                                className="sb-comms-first-page sb-comms-intro-img pb-3 pb-md-0"
                            >
                                <img src={nyImage2} />
                            </UiCol>
                            <UiCol
                                lg="5"
                                className="sb-comms-second-page sb-comms-intro-img pb-3 pb-md-0"
                            >
                                <img src={nyImage2} />
                            </UiCol>
                            <UiCol
                                lg="12"
                                className="sb-comms-large-page sb-comms-intro-img pt-4 pb-3 pb-md-0"
                            >
                                <img src={nyImage2} />
                            </UiCol>
                        </UiSingleRow>
                    </UiCol>
                    <UiCol lg="5" className="sb-comms-slider">
                        
                    </UiCol>
                </UiSingleRow>
            </UiContentWr>
            {/* <Footer />
            </UiMainWrapper> */}
        </>
    );
}
